// src/components/remediationScorecardView.js
// The Remediation Scorecard's view logic that needs no layout: narrowing sources to a search, and finding the current source.

const matches = (value, term) => (value ?? "").toLowerCase().includes(term);

/**
 * The sources left after a search, ignoring case and surrounding spaces. A blank search returns `sources` itself.
 * A source whose label matches keeps every row; any other source keeps its matching rows, or is left out if none match.
 * Subtotals are not recomputed, and the input is never mutated.
 */
export const filterScorecardSources = (sources, query) => {
    const term = String(query ?? "").trim().toLowerCase();
    if (term === "") return sources;

    const filtered = [];
    sources.forEach((source) => {
        if (matches(source.label, term)) {
            filtered.push(source);
            return;
        }
        const keptRows = (source.rows ?? []).filter((row) =>
            matches(row.category, term) || (row.originalCategories ?? []).some((entry) => matches(entry, term)));
        if (keptRows.length > 0) filtered.push({ ...source, rows: keptRows });
    });
    return filtered;
};

/**
 * The index of the source at the top of the scrolled table, from each source's first-row `offsetTop` in table order.
 * Returns -1 with no sources, and the last source when the box is scrolled to its end, even if that source can't reach the top.
 * Otherwise the last source whose first row is at or above the header's bottom edge (1px tolerance for sub-pixel offsets), or 0 if none is.
 */
export const activeSourceIndex = (rowTops, scrollTop, headerHeight, atBottom) => {
    if (rowTops.length === 0) return -1;
    if (atBottom === true) return rowTops.length - 1;

    let active = 0;
    rowTops.forEach((top, index) => {
        if (top <= scrollTop + headerHeight + 1) active = index;
    });
    return active;
};
